import { z } from "zod";
import { userIdSchema } from "./identity.js";
export const widgetSchema = z.object({
    id: z.string(),
    kind: z.string(),
    title: z.string(),
    body: z.string(),
    data: z.record(z.string(), z.unknown()).default({}),
    deepLink: z.string().nullable().default(null),
});
export const homepageStateSchema = z.object({
    userId: userIdSchema,
    featured: widgetSchema.nullable(),
    secondary: z.array(widgetSchema),
    updatedAt: z.coerce.date(),
});
//# sourceMappingURL=homepage.js.map